import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import CardsGridPreview from "@project/components/CardsGrid/CardsGridPreview";
export const CardItem = {
    label: "Ensemble d'informations",
    key: "items",
    type: ContentsCustomTypes.CARDS_GRID_ITEM,
    children: [
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Sous titre",
            key: "subtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
    ],
};
export const CardsGrid = {
    label: "Bloc de cartes",
    type: ContentsCustomTypes.CARDS_GRID,
    Preview: CardsGridPreview,
    icon: "th",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [CardItem],
                    value: ContentsCustomTypes.CARDS_GRID_ITEM,
                },
            ],
        },
    ],
};
